import { Flex, Select, Text } from "@mantine/core";
import dayjs from "dayjs";
import type { FC, ReactNode } from "react";
import { useEffect, useState } from "react";
import { hoursItems, timesItems } from "src/const/time";

import styles from "./CreateForm.module.scss";

export const TimePicker: FC<{
  day?: Date;
  value?: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  error?: ReactNode;
  onSelect: (valueString?: string | null, day?: Date | null) => void;
}> = ({ label, required, disabled, value, day: initDay, error, onSelect }) => {
  const [day, setDay] = useState<Date | undefined>(initDay);
  const [hour, setHour] = useState<string | undefined | null>(value);
  const [minute, setMinute] = useState<string | undefined | null>(value);
  useEffect(() => {
    if (value) {
      const [h, m] = value.split(":");
      setHour(h);
      setMinute(m);
    }
  }, [value]);
  useEffect(() => {
    setDay(initDay);
  }, [initDay]);

  return (
    <Flex pos="relative" direction={"column"} align="flex-start">
      {label && (
        <label htmlFor="startTimeId">
          {label} {required && <span className={styles.required}>※必須</span>}
        </label>
      )}
      <Flex
        pos="relative"
        align="center"
        justify="space-between"
        color="#333"
        mt={"10px"}
        gap={5}
      >
        <Select
          disabled={disabled}
          value={hour}
          placeholder="時"
          w={"70px"}
          data={hoursItems}
          onChange={(h) => {
            setHour(h);
            const newValue = h
              ? dayjs(day)
                  .minute(+(minute || 0))
                  .hour(+h)
                  .toDate()
              : undefined;
            onSelect(h, newValue);
          }}
        />
        <span>:</span>
        <Select
          disabled={!hour || disabled}
          value={minute}
          placeholder="分"
          w={"70px"}
          data={timesItems}
          onChange={(m) => {
            setMinute(m);
            const newValue = m
              ? dayjs(day)
                  .minute(+m)
                  .hour(+(hour || 0))
                  .toDate()
              : undefined;
            onSelect(m, newValue);
          }}
        />
      </Flex>
      {error && (
        <Text color="#fa5252" fz={12} mt={5}>
          {error}
        </Text>
      )}
    </Flex>
  );
};
